import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { DatasetFacade, PublishDialogService } from '@mode/dataset/contract';
import { PublishDatasetDialogComponent } from './publish-dataset-dialog.component';
import { take } from 'rxjs/operators';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Injectable()
export class PublishDatasetDialogService extends PublishDialogService {
  constructor(
    private dialogService: DialogService,
    private datasetFacade: DatasetFacade,
    private metaTag: MetaTagsService,
    private analyticsService: AnalyticsService
  ) {
    super();
  }

  public override open(switchViewToken: string) {
    const currentDialog = this.dialogService.open({
      component: PublishDatasetDialogComponent,
      matDialogConfig: {
        data: {
          switchViewToken,
        },
      },
    });

    this.listenToDialogEvent(currentDialog);
  }

  private listenToDialogEvent(currentDialog: MatLegacyDialogRef<PublishDatasetDialogComponent>) {
    currentDialog.componentInstance.publish
      .pipe(take(1))
      .subscribe(({ newDatasetName, datasetToken, producerType, queryToken, switchViewToken }) => {
        this.datasetFacade.publishDataset(datasetToken, newDatasetName, producerType, queryToken, switchViewToken);
        const eventData = {
          context: this.analyticsService.context,
          location: AnalyticsEvent.SubContext.PublishDatasetModal,
          action: AnalyticsEvent.Name.DatasetPublished,
          name: this.metaTag.getTag(MetaTags.CurrentUsername),
          producerType,
        };
        this.analyticsService.track(AnalyticsEvent.Name.UiClicked, eventData);
      });
  }
}
